/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBusinessChowlyBody
 */
export interface UpdateBusinessChowlyBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessChowlyBody
     */
    chowlyApi: string;
}

/**
 * Check if a given object implements the UpdateBusinessChowlyBody interface.
 */
export function instanceOfUpdateBusinessChowlyBody(value: object): value is UpdateBusinessChowlyBody {
    if (!('chowlyApi' in value) || value['chowlyApi'] === undefined) return false;
    return true;
}

export function UpdateBusinessChowlyBodyFromJSON(json: any): UpdateBusinessChowlyBody {
    return UpdateBusinessChowlyBodyFromJSONTyped(json, false);
}

export function UpdateBusinessChowlyBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBusinessChowlyBody {
    if (json == null) {
        return json;
    }
    return {
        
        'chowlyApi': json['chowlyApi'],
    };
}

export function UpdateBusinessChowlyBodyToJSON(json: any): UpdateBusinessChowlyBody {
    return UpdateBusinessChowlyBodyToJSONTyped(json, false);
}

export function UpdateBusinessChowlyBodyToJSONTyped(value?: UpdateBusinessChowlyBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'chowlyApi': value['chowlyApi'],
    };
}

